<template>
  <VView class="contest-game" back-button-to="/menu" header="Konkurs">
    <!-- <VGame @end="onGameEnd($event)" /> -->
     <VText center>Konkurs został zakończony.</VText>
     <VText center small>Listę laureatów opublikujemy wkrótce.</VText>
  </VView>
</template>

<script>
import VGame from '@/games/vue-photo/VGame.vue';
import { SET_ATTACHMENT, SET_SCORE } from '@/store';

export default {
  name: 'ContestGame',

  components: {
    VGame,
  },

  methods: {
    onGameEnd({ attachment, score }) {
      this.$store.commit(SET_ATTACHMENT, { attachment });
      this.$store.commit(SET_SCORE, { score });

      this.$router.push('/contest/personal');
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-game {}
</style>
